import dayjs from "dayjs";
import { atom, useAtom, useAtomValue } from "jotai";

const timeframeDaysAtom = atom(7);

const timeframeDateAtom = atom((get) => {
  const days = get(timeframeDaysAtom);
  return dayjs().subtract(days, "day").toDate();
});

export function useTimeframe() {
  const [days, setDays] = useAtom(timeframeDaysAtom);
  const date = useAtomValue(timeframeDateAtom);
  return { date, days, setDays } as const;
}
